import type { SecuritySchemaTreeContext } from 'components/SecuritySchema/SecuritySchemaTreeContext';
import {
  type SecuritySchemaNode,
  isChainItemNode,
} from 'components/SecuritySchema/model/SecuritySchemaNode';

/**
 * Whether this node is the chain item the path lookup decided on. Keyed on the
 * item's position among the page's chain items, not its tree path — a cloud rule
 * sits one level deeper, inside its policy's box. A policy box is an item too
 * when it stands in for the rule that runs that policy, so a staged cloud
 * enforcement highlights the policy passed through as well as the final rule.
 */
export const isHighlightedChainItem = (
  node: SecuritySchemaNode,
  context: SecuritySchemaTreeContext,
): boolean =>
  isChainItemNode(node) &&
  node.pageIndex !== undefined &&
  context.paginatedHighlightedRuleIndex === node.pageIndex;
